import moment from "moment";

export function getUrlExtension( url ){
    if(!url || typeof url !== "string" || !url.split(/[#?]/).length || !url.split(/[#?]/)[0] ||
        !url.split(/[#?]/)[0].split('.') || !url.split(/[#?]/)[0].split('.').pop()){
        return ""
    }
    return url.split(/[#?]/)[0].split('.').pop().trim();
}

export function boardMatchesSearch(board, search,filters= {}){
    if(filters["layer"] && filters["layer"].length){
        if(!board.fields["layer"] && filters["layer"].includes("undefined")){
        } else if(!board.fields["layer"] || !filters["layer"].includes(board.fields["layer"])){
            return false
        }
    }
    if(filters["status"] && filters["status"].length){
        if(!board["status"] && filters["status"].includes("undefined")){
        } else if(!board["status"] || !filters["status"].includes(board["status"])){
            return false
        }
    }
    if(filters["vendor"] && filters["vendor"].length){
        if(!board.fields["vendor"] || !filters["vendor"].includes(board.fields["vendor"])){
            return false
        }
    }
    if(filters["market"] && filters["market"].length){
        if(!board.fields["market"] || !filters["market"].includes(board.fields["market"])){
            return false
        }
    }
    if(filters["media format"] && filters["media format"].length){
        if(!board.fields["media format"] || !filters["media format"].includes(board.fields["media format"])){
            return false
        }
    }
    if (!search || search.length < 3){
        return true
    }
    search = search.toLowerCase();
    if(board.fields["media format"] && board.fields["media format"].toLowerCase().includes(search)){
        return true
    }
    if(board.fields["unit #"] && ("" + board.fields["unit #"]).toLowerCase().includes(search)){
        return true
    }
    if(board.fields["description"] && board.fields["description"].toLowerCase().includes(search)){
        return true
    }
    if(board.fields["vendor"] && (""+board.fields["vendor"]).toLowerCase().includes(search)){
        return true
    }
    if(board.fields["market"] && (""+board.fields["market"]).toLowerCase().includes(search)){
        return true
    }
    if(search.includes("not favorite")){
        if( !board.favorite){
            return true
        }
        return false
    }
    if(search.includes("favorite") && board.favorite){
        return true
    }
    return false
}

export function GetSelectedBoards(boards,search){
    let selectedBoards = {};
    for(let key in boards){
        if(boards[key].selected && boardMatchesSearch(boards[key],search)){
            selectedBoards[key] = boards[key];
        }
    }
    return selectedBoards
}

/* 
group array items by given criteria
the result type is: { [group_name: string]: item[] } 
*/
export function GroupByProperty(items, callbackFn) {
    return items.reduce((acc, obj) => {
        const key = callbackFn(obj);

        if (!acc[key]) {
            acc[key] = [obj];
        } else {
            acc[key] = [...acc[key], obj];
        }

        return acc;
    }, {});
}

export function GetBoardsGroupedByUnit(campaign) {
    console.log("GetBoardsGroupedByUnit")
    try {
        let result = {};
        if (Object.keys(campaign.boards).length) {
            // Key the result by the board's object key in campaign.boards (the same key the
            // sidebar/map use to look boards up), NOT by board.vendorId. Some boards (e.g. ones
            // added via the XLSX upload path) can have an undefined vendorId property; keying by
            // vendorId collapsed all of those into a single bucket, so they vanished from the
            // list/rows view while still showing in grid view. For healthy boards the object key
            // equals vendorId, so this is a no-op for them.
            // group [key, board] entries by the first part of unit #
            const groupedObj = GroupByProperty(Object.entries(campaign.boards), ([, { fields }]) => (""+fields["unit #"]).split('.')[0]);
            for (const group in groupedObj) {
                let items = groupedObj[group];
                if (items.length > 1) {
                    const children = items.filter(([, { fields }]) => (""+fields["unit #"]).split('.').length >= 2);
                    const parents = items.filter(([, { fields }]) => (""+fields["unit #"]).split('.').length < 2);
                    if (children.length > 0 && parents.length === 1) {
                        // one parent with .n-suffixed children — standard hierarchy
                        children.sort(([, a], [, b]) => (""+a.fields["unit #"]).split('.')[1] - (""+b.fields["unit #"]).split('.')[1]);
                        result[parents[0][0]] = {
                            ...parents[0][1],
                            childBoards: children.map(([, b]) => b),
                        };
                    } else {
                        // multiple boards with the same plain unit # (duplicates) — show all top-level
                        for (const [key, item] of [...parents, ...children]) {
                            result[key] = { ...item };
                        }
                    }
                } else {
                    result[items[0][0]] = {
                        ...items[0][1],
                    };
                }
            }
        }
        return result;
    } catch (err) {
        console.error(err)
        return campaign.boards;
    }
}

export function GetSortedVendorIds(campaign){
    var sortedVendorIds = [];
    // if(Object.keys(campaign.boards).length && campaign.boards[Object.keys(campaign.boards)[0]].index !== undefined){
    //     for (var vendorId in campaign.boards) {
    //         sortedVendorIds.push({vendorId: vendorId, index: campaign.boards[vendorId].index});
    //     }
    //     sortedVendorIds.sort(function(a, b) {
    //         return a.index - b.index ;
    //     });
    // }else{
    for (var vendorId in campaign.boards) {
        sortedVendorIds.push({vendorId: vendorId, "unit #": ""+campaign.boards[vendorId].fields["unit #"]});
    }
    sortedVendorIds.sort(function(a, b) {
        const unitA = a["unit #"];
        const unitB = b["unit #"];

        // Check if both values are numeric (even if they're provided as strings)
        if (!isNaN(unitA) && !isNaN(unitB)) {
            // Compare as numbers
            return Number(unitA) - Number(unitB);
        } else {
            // At least one is a string, so compare alphabetically
            return ("" + unitA).localeCompare("" + unitB);
        }
    });
    // }
    return sortedVendorIds
}

export function CalcOverride(board){
    let baseDays = moment(board.fields["end date"]).diff(moment(board.fields["start date"]), 'days');
    let mediaCost = baseDays * (board.fields["neg rate"]/28);
    if(!["completed","posted"].includes(board.status)){
        return {
            overridePercent:"",
            bonusImpressions: 0,
            overrideMediaValue: 0,
            baseDays:baseDays,
            extraDays: 0,
            mediaCost: Math.round(mediaCost * 100)/100,
        }
    }
    //get extra days (today - posted)
    let takedown = moment();
    if(board.fields["takedown date"]){
        takedown = moment(board.fields["takedown date"]);
    }
    let totalDays = takedown.diff(moment(board.fields["install date"]), 'days');
    if (totalDays < 0 || totalDays < baseDays){
        return {
            baseDays:baseDays,
            extraDays: 0,
            overridePercent:"",
            bonusImpressions: 0,
            overrideMediaValue: 0,
            mediaCost: Math.round(mediaCost * 100)/100,
        }
    }
    let extraDays = totalDays - baseDays;
    let overridePercent = extraDays/baseDays;
    let bonusImpressions = extraDays * (board.fields["4-wk imp"]/28);//extra days * daily impressions
    let overrideMediaValue = extraDays * (board.fields["neg rate"]/28);//extra days * daily cost
    return {
        baseDays:baseDays,
        extraDays: extraDays,
        overridePercent: Math.round(overridePercent * 1000)/10+"%",
        bonusImpressions: Math.round(bonusImpressions),
        overrideMediaValue: Math.round(overrideMediaValue),
        mediaCost: Math.round(mediaCost * 100)/100,
    }
}

export function ActivityTracker(boards){
    let confirmed = 0;
    let posted = 0;
    let totalCost = 0;
    let overrideValue = 0;
    for (let boardId in boards){
        let board = boards[boardId]
        let o = CalcOverride(board);
        switch (board.status){
            case "confirmed":
                confirmed++;
                break;
            case "posted":
                confirmed++;
                posted++;
                if (isFinite(o.mediaCost) && o.mediaCost > 0) {
                    totalCost += o.mediaCost;
                    overrideValue += isFinite(o.overrideMediaValue) ? o.overrideMediaValue : 0;
                }
                break;
            case "completed":
                posted++;
                confirmed++;
                if (isFinite(o.mediaCost) && o.mediaCost > 0) {
                    totalCost += o.mediaCost;
                    overrideValue += isFinite(o.overrideMediaValue) ? o.overrideMediaValue : 0;
                }
                break;
        }
    }
    return {
        posted:posted,
        confirmed: confirmed,
        postedPercent: Math.round(posted/confirmed * 1000)/10,
        override: totalCost > 0 ? Math.round(overrideValue/totalCost * 1000)/10 : 0,
    }
}

export function GetStatusCounts(boards){
    let statuses = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(statuses[board.status]){
            statuses[board.status]++;
        }else{
            statuses[board.status] = 1;
        }
    }
    return statuses;
}

export function GetLayerCounts(boards){
    let layers = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(layers[board.fields["layer"]]){
            layers[board.fields["layer"]]++;
        }else{
            layers[board.fields["layer"]] = 1;
        }
    }
    return layers;
}

export function GetFormatCounts(boards){
    let formats = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(formats[board.fields["media format"]]){
            formats[board.fields["media format"]]++;
        }else{
            formats[board.fields["media format"]] = 1;
        }
    }
    return formats;
}

export function GetVendorCounts(boards){
    let formats = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(formats[board.fields["vendor"]]){
            formats[board.fields["vendor"]]++;
        }else{
            formats[board.fields["vendor"]] = 1;
        }
    }
    return formats;
}

export function GetMarketCounts(boards){
    let formats = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(formats[board.fields["market"]]){
            formats[board.fields["market"]]++;
        }else{
            formats[board.fields["market"]] = 1;
        }
    }
    return formats;
}

/**
* Search params are held as an array of two elements arrays where member 0 is the key and member 1 is value
* This function converts params to the format that we use to store filters in state
*/
export function parseExistingParams(searchParams) {
    const entries = Array.from(searchParams.entries());
    return entries.reduce((acc, a) => ((acc[a[0]] = acc[a[0]] || []).push(a[1]), acc), {});
}

/**
* Converts object with filters selected to URLSearchParams format
*/
export function convertStateToParams(filters) {
    const searchParams = [];
    
    for (const key in filters) {
        if (Array.isArray(filters[key])) {
            for (const value of filters[key]) {
                searchParams.push([key, value]);
            }
        } else {
            searchParams.push([key, filters[key]]);
        }
    }

    return searchParams;
}

export function updateFilters(filters, key, value) {
    if (filters[key].includes(value)) {
        filters[key].splice(filters[key].indexOf(value), 1);
    } else {
        filters[key].push(value);
    }

    return filters;
}
export function IsEmailValid(email) {
    if (!email?.trim()) {
        return false;
    }

    const regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]+$/g);
    return regex.test(email);
}

// Keep in sync with MASTER_OWNERS in server/controllers/CampaignController.js.
// Master owners have full access to every campaign.
export const MASTER_OWNERS = ['roncorvino@epl.media', 'caseycorvino@epl.media'];

export function IsMasterOwner(user) {
    return !!user?.email && MASTER_OWNERS.includes(user.email);
}

// campaign.otherOwners entries exist in three shapes in the DB — an embedded
// user object, a plain string id, or an ObjectId serialized to a string —
// because the schema types them as a bare Object and never cast them.
// Keep in sync with server/helpers/OwnerHelper.js.
export function OwnerId(entry) {
    if (!entry) return null;
    if (typeof entry === 'string') return entry;
    if (entry._id) return String(entry._id);
    return String(entry);
}

export function IsUserOwner(user, campaign) {
    if (!user || !campaign) {
        return false;
    }

    if (IsMasterOwner(user)) {
        return true;
    }

    return OwnerId(campaign.owner) === OwnerId(user._id) ||
        campaign.otherOwners?.some(owner => OwnerId(owner) === OwnerId(user._id));
}

export function IsUserPrimaryOwner(user, campaign) {
    if (!user || !campaign) {
        return false;
    }

    return user._id === campaign.owner;
}

export function FormatNumber(n) {
    if(typeof n !== "number"){
        return n
    }
    if (n < 1000) {
        return n.toString();
    }

    if (n < 1_000_000) {
        return (n / 1000).toFixed(2).replace(/\.00$/, "") + "K";
    }

    return (n / 1_000_000).toFixed(2).replace(/\.00$/, "") + "M";
}